import { ButtonProps, Button } from 'antd';
import React, { FC, useState, useCallback } from 'react';

export const ButtonWithLoading: FC<ButtonProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const onClick = useCallback(async (event) => {
    if (props?.onClick) {
      setLoading(true);
      await props.onClick(event);
      setLoading(false);
    }
  }, [props]);
  return <Button loading={loading} {...props} onClick={onClick} style={props.style}>{props.children}</Button>;
};
